export default "__VITE_ASSET__bXyNwrKX__"